import styled from 'styled-components';

export const Trip = styled.div`
  cursor: auto;

  @media (max-width: 1280px) {
    padding-top: 6px;
  }
`;
